import React from 'react';
import './LevelClass.css';

function LevelClass({education_class, enrolled, views}) {
  return (
    <div className='level-class-container'>
        <p className='about-teacher-title-text'>Class Status</p>
        <div className='level-class-layout'>
        <div className='level-class'>
            <span className='level-display'>{education_class}</span>
            <span className='level-teacher-text'>Education Level</span>
        </div>
        <div className='level-class'>
            <span className='level-display'>{enrolled}</span>
            <span className='level-teacher-text'>Students</span>
        </div>
        <div className='level-class'>
            <span className='level-display'>{views}</span>
            <span className='level-teacher-text'>Projects</span>
        </div>
        </div>
    </div>
  )
}

export default LevelClass